import React, { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import {
  DropdownBox,
  CustomDropdown,
  InputBox,
  SubmitButton,
} from "../../components/Input";
import { API_URL } from "../../config";
import axios from "axios";
import { showToast } from "../../components/toast";

const EditPerformance = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState({
    serviceid: 0,
    action: 0,
    symbol: "",
    quantity: 0,
    entry_price: 0,
    target_price: 0,
    target2_price: 0,
    stoploss: 0,
    duration: "",
    description: "",
    status: 1,
    exchange: "",
    service_name: "",
    notify: 1,
    price_action: "",
    closeprice: 0, // ✅ match API field
  });

  useEffect(() => {
    if (id) {
      const token = localStorage.getItem("authToken");
      axios
        .get(`${API_URL}researchCalls/${id}`, {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        })
        .then((res) => {
          const data = res.data;
          setFormData((prev) => ({
            ...prev,
            serviceid: data.serviceid || 0,
            action: data.action || 0,
            symbol: data.symbol || "",
            quantity: data.quantity || 0,
            entry_price: parseFloat(data.entry_price) || 0,
            target_price: parseFloat(data.target_price) || 0,
            target2_price: parseFloat(data.target2_price) || 0,
            stoploss: parseFloat(data.stoploss) || 0,
            duration: data.duration || "",
            exchange: data.exchange || "",
            service_name: data.service_name || "",
            status: data.status || 1,
            price_action: data.price_action || "",
            closeprice: parseFloat(data.closeprice) || 0, // ✅ map correctly
          }));
        })
        .catch((err) => {
          console.error("Failed to fetch data", err);
          showToast.error("Failed to fetch performance data");
        });
    }
  }, [id]);

  // ✅ Handles both InputBox & DropdownBox
  const handleChange = (e) => {
    const { name, value } = e.target;

    setFormData((prev) => ({
      ...prev,
      [name]:
        name === "status" || name === "action" || name === "quantity"
          ? parseInt(value, 10)
          : name === "entry_price" ||
            name === "target_price" ||
            name === "target2_price" ||
            name === "stoploss" ||
            name === "closeprice"
            ? parseFloat(value)
            : value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const token = localStorage.getItem("authToken");

    const payload = {
      id: parseInt(id),
      action: parseInt(formData.action),
      quantity: parseInt(formData.quantity),
      entry_price: parseFloat(formData.entry_price),
      target_price: parseFloat(formData.target_price),
      target2_price: parseFloat(formData.target2_price),
      closeprice: parseFloat(formData.closeprice) || 0,
      stoploss: parseFloat(formData.stoploss),
      status: parseInt(formData.status), // ✅ always integer
    };

    try {
      setLoading(true);
      const response = await axios.patch(
        `${API_URL}researchCalls/save`,
        payload,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      );

      if (response.status === 200) {
        showToast.success("Performance updated successfully");
        setTimeout(() => {
          navigate("/research/performance");
        }, 500); // ✅ small delay before redirect
      } else {
        showToast.error(
          response.data.message || "Failed to update performance"
        );
      }
    } catch (error) {
      console.error("Error updating performance:", error);
      showToast.error("Error updating performance");
      setLoading(false);
    }
  };

  const actionOptions = [
    { value: 1, label: "BUY" },
    { value: 2, label: "SELL" },
  ];

  const statusOptions = [
    { value: 1, label: "Activate" },
    { value: 2, label: "Target 1 Hit" },
    { value: 3, label: "Target 2 Hit" },
    { value: 4, label: "Stoploss" },
    { value: 5, label: "Closed" },
    { value: 6, label: "Delete Performance" },
  ];

  return (
    <div
      id="page-container"
      className="page-header-fixed page-sidebar-fixed fade in"
    >
      <div id="content" className="">
        <div className="panel panel-default with-rounded-corner with-shadow">
          <form onSubmit={handleSubmit} className="stdform">
            <input type="hidden" name="id" value={id} />
            <div className="panel-heading border-0">
              <span className="panel-title">Edit Performance</span>
            </div>
            <div className="panel-body">
              <div className="row">
                <div className="col-md-2">
                  <InputBox
                    label="Exchange"
                    fieldname="exchange"
                    value={formData.exchange}
                    onChange={handleChange}
                    disabled
                  />
                </div>

                <div className="col-md-3">
                  <InputBox
                    label="Service"
                    fieldname="service_name"
                    value={formData.service_name}
                    onChange={handleChange}
                    disabled
                  />
                </div>
                <div className="col-md-2">
                  <DropdownBox
                    label="Action"
                    fieldname="action"
                    options={actionOptions}
                    value={formData.action}
                    onChange={handleChange}
                    disabled={true}
                  />
                </div>
                <div className="col-md-5">
                  <InputBox
                    label="Symbol"
                    fieldname="symbol"
                    value={formData.symbol}
                    onChange={handleChange}
                    disabled
                  />
                </div>
                <div className="col-md-2">
                  <InputBox
                    label="Price Action"
                    fieldname="price_action"
                    value={formData.price_action}
                    onChange={handleChange}
                    disabled
                  />
                </div>
                <div className="col-md-2">
                  <InputBox
                    label="Quantity"
                    fieldname="quantity"
                    type="number"
                    value={formData.quantity}
                    onChange={handleChange}
                    disabled
                  />
                </div>
                <div className="col-md-2">
                  <InputBox
                    label="Duration"
                    fieldname="duration"
                    value={formData.duration}
                    onChange={handleChange}
                    disabled
                  />
                </div>
                <div className="col-md-2">
                  <InputBox
                    label="Entry Price"
                    fieldname="entry_price"
                    type="number"
                    value={formData.entry_price}
                    onChange={handleChange}
                  />
                </div>
                <div className="col-md-2">
                  <InputBox
                    label="Target Price"
                    fieldname="target_price"
                    type="number"
                    value={formData.target_price}
                    onChange={handleChange}
                  />
                </div>
                <div className="col-md-2">
                  <InputBox
                    label="Target2 Price"
                    fieldname="target2_price"
                    type="number"
                    value={formData.target2_price}
                    onChange={handleChange}
                  />
                </div>
                <div className="col-md-2">
                  <InputBox
                    label="Stoploss"
                    fieldname="stoploss"
                    type="number"
                    value={formData.stoploss}
                    onChange={handleChange}
                  />
                </div>
                <div className="col-md-2">
                  <InputBox
                    label="Close Price"
                    fieldname="closeprice"
                    type="number"
                    value={formData.closeprice}
                    onChange={handleChange}
                  />
                </div>
                <div className="col-md-4">
                  <CustomDropdown
                    label="Status"
                    fieldname="status"
                    options={statusOptions}
                    onChange={handleChange}
                    value={formData.status}
                  />
                </div>
              </div>

              <div className="row">
                <SubmitButton
                  pageBack="/research/performance"
                  handleSubmit={handleSubmit}
                  loading={loading}
                />
              </div>
            </div>
          </form>
        </div>
        <a href="#" className="btn-scroll-top fade">
          <i className="ti-arrow-up"></i>
        </a>
      </div>
    </div>
  );
};

export default EditPerformance;
